module.exports = __webpack_public_path__ + "assets/ditu.a3696aa1.svg";